export enum CCPAParams {
  CAMPAIGN_CODE_PARAM = "campaignCode",
  PID_PARAM = "pid",
  CHANNEL_PARAM = "chnl",
  LANGUAGE = "lang"
}

export enum SourceChannel {
  CCPA = "CCPA"
}

export enum CARDS {
  AIB = "AIB",
  MCB = "MCB"
}